export default __webpack_public_path__ + "bb36aad011f812a506bfffeef3228660.png";